import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMenuComponent } from './app-menu.component';

import { jqxButtonModule } from 'jqwidgets-ng/jqxbuttons';
import { jqxDropDownListModule } from 'jqwidgets-ng/jqxdropdownlist';
import { jqxLoaderModule } from 'jqwidgets-ng/jqxloader';
import { jqxInputModule } from 'jqwidgets-ng/jqxinput';
import { FormsModule } from '@angular/forms';
import { jqxGridModule } from 'jqwidgets-ng/jqxgrid';

@NgModule({
  declarations: [AppMenuComponent],
  imports: [
    CommonModule,
    FormsModule,
    jqxLoaderModule,
    jqxButtonModule,
    jqxDropDownListModule,
    jqxInputModule,
    jqxGridModule,
  ],
  exports: [AppMenuComponent],
})
export class AppMenuModule {}
